/** Re-emissions keep their sort anchor; a new lifecycle transition gets a fresh one. */
export function resolveThreadUnsettledAt(
  thread:
    | {
        readonly settledOverride: "active" | "settled" | null;
        readonly unsettledAt?: string | null | undefined;
      }
    | undefined,
  reason: "user" | "activity",
  updatedAt: string,
): string {
  const nextOverride = reason === "user" ? "active" : null;
  return thread?.settledOverride === nextOverride ? (thread.unsettledAt ?? updatedAt) : updatedAt;
}
